<template>
  <button
    class="header-menu-button"
    :class="toggleclass"
    @click="toggle"
  >
    <div
      class="header-menu-button-icon"
      aria-hidden="true"
    />
    <div class="header-menu-button-text">
      {{ openerText }}
    </div>
  </button>
</template>

<script>
export default {
  name: 'mobile-nav-content-fullpage-nav',
  data() {
    return {
      menuDisplayed: false
    }
  },
  computed: {
    toggleclass() {
      return this.menuDisplayed ? 'menu-opened' : 'menu-closed'
    },
    openerText() {
      return this.menuDisplayed ? 'Close' : 'Menu'
    }
  },
  created() {
    this.$eventHub.$on('hideMobileMenu', this.hideMobileMenu)
    this.$eventHub.$on('showMobileMenu', this.showMobileMenu)
  },
  methods: {
    toggle() {
      this.$eventHub.$emit(
        this.menuDisplayed ? 'hideMobileMenu' : 'showMobileMenu'
      )
    },
    hideMobileMenu() {
      this.menuDisplayed = false
    },
    showMobileMenu() {
      this.menuDisplayed = true
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~@scss/custom.scss";

//header menu buttono and toggle
.header-menu-button-text {
  position: absolute;
  color: var(--header-menu-button-text-color);
  @include transition(color 0.3s);
  font-size: 0.8em;
  bottom: 0;
  line-height: 1;
}

.header-menu-button {
  display: flex;
  justify-content: center;
  align-items: center;
  width: var(--header-menu-button-size);
  height: var(--header-menu-button-size);
  position: relative;
  background-color: var(--header-menu-button-background-color);
  //resets
  border: 0;
  outline: none;
  padding: 0;
  padding-bottom: 1rem;
  cursor: pointer;
  @include hover-focus {
    .header-menu-button-icon {
      &::after {
        width: 100%;
      }
    }
  }
}

// icon
.header-menu-button-icon {
  position: relative;
  display: block;
  font-size: var(--header-menu-button-icon-size);
  width: 2rem;
  height: var(--header-menu-button-icon-stroke);
  color: var(--header-menu-button-icon-color); // icon color
  background-image: linear-gradient(
    var(--header-menu-button-icon-color),
    var(--header-menu-button-icon-color)
  );
  background-repeat: no-repeat;
  transform: scale(1);

  &::before,
  &::after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    background-image: inherit;
    border-radius: inherit;
  }
  //lower line
  &::after {
    width: 60%;
    transition: transform 0.3s;
  }
}

// menu to 'X' close
.header-menu-button-icon {
  background-size: 100% 100%;
  will-change: transform, background-size;
  transition: transform 0.3s, background-size 0.3s, background-color 0.3s;

  .header-menu-button:active & {
    transform: scale(0.9);
  }

  &::before,
  &::after {
    will-change: inherit;
    transition: inherit;
  }

  &::before {
    //line top
    transform: translateY(-0.55rem) rotate(0);
  }

  &::after {
    //line bottom
    transform: translateY(0.55rem) rotate(0);
  }
}

//when menu is opened transition
.menu-opened {
  .header-menu-button-icon {
    background-size: 0% 100%;
    &::before,
    &::after {
      width: 100%;
    }
    &::before {
      transform: translateY(0) rotate(45deg);
    }

    &::after {
      transform: translateY(0) rotate(-45deg);
    }
  }
}
</style>
